import LoaderComponent from "../Loader/Loader";
const Button = ({
  isLoading = false,
  onClick = null,
  handleSave = null,
  pageId = "", 
  id = "",
  disabled = false,
  btnText = "Save",
  className = "",
  disabledClassName = "",
}) => {
  return (
    <>
      <button
        disabled={isLoading || disabled}
        onClick={onClick ? () => onClick() : () => handleSave ? handleSave(pageId, id) : null}
        style={{
          width: "100px",
          display: "flex",
          justifyContent: "center",
        }}
        className={
          disabled ? disabledClassName ? disabledClassName : "text-white btn bg-custom-500 border-custom-500" :
            className ? className : "text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"}
      >
        {isLoading ? <LoaderComponent /> : btnText}
      </button>
    </>
  );
};

export default Button;
